//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
    return {
       isComplex:false,
       isMousedown:false,
       isMousedownList:[],    
       isMouseup:false,
       isMouseupList:[],
       buildList:[],
       saleStatusList:[],
       isTransverseVue:false,
      //  overflow: scroll;
    };
  },
  created() {
    this.handleToNextStep()
  },
  computed:{
      
  },
  watch:{
    isOpening:{
       handler:function(newval,oldval){
           if(this.isOpening){
              console.log('调用放盘',this.isOpening)
              //生成图片
              this.openSave()
              this.isOpening=false
           }
       },
       deep: true
    },
     isClosing:{
       handler:function(newval,oldval){
           if(this.isClosing){
              console.log('调用放盘',this.isClosing)
              //生成图片
              this.closeSave()
              this.isClosing=false
           }
       },
       deep: true
    },
     buildBeanList:{
       handler:function(newval,oldval){
            console.log('buildBeanList变化')
            this.buildList=this.cloneDeepJson(this.buildBeanList)    
       },
       deep: true
     },
     saleStatusBeanList:{
       handler:function(newval,oldval){
            this.saleStatusList=this.saleStatusBeanList
       },
       deep: true
     },
     isTransverse:{
       handler:function(newval,oldval){
            this.isTransverseVue=this.isTransverse
            // console.log('方向',this.isTransverseVue)
            if(this.isTransverse==null||this.isTransverse==undefined){
               this.isTransverseVue=false
            }
       },
       deep: true
     },
  },
  props: {
    buildBeanList: Array,
    saleStatusBeanList:Array,
    model: Object,
    getLangMsg: Function,
    invoke: Function,
    isTransverse:Boolean,
    isOpening:Boolean,
    isClosing:Boolean
  },
  methods: {
    handleToNextStep: function () {
      console.log('init_data')
      this.invoke('invokeCustomEvent',{content:{ type: 'init_data', value:''}})
    },
    openSave(){
       let roomId=[]
       
            this.buildList.forEach(item=>{
               item.floorBeanList.forEach(i=>{
               i.unitBeanList.forEach(ii=>{
                  ii.roomBeanList.forEach(iii=>{
                     if(iii.isSelect){
                        roomId.push(iii.id)
                     }  
                  })
               })
            })
          })
         let value={
            roomIds:roomId
         }
         let parm={content:{ type:'opening_quotation_data', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
    },
    closeSave(){
       let roomId=[]
           
            this.buildList.forEach(item=>{
               item.floorBeanList.forEach(i=>{
               i.unitBeanList.forEach(ii=>{
                  ii.roomBeanList.forEach(iii=>{
                     if(iii.isSelect){
                        roomId.push(iii.id)
                     }  
                  })
               })
            })
          })
         let value={
            roomIds:roomId
         }
         let parm={content:{ type:'closing_quotation_data', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
    },
    //改变全选
    changeAllSelect(num){
      //改变全选
      this.buildList[num].AllisSelect=!this.buildList[num].AllisSelect//全部选中或取消
      if(this.buildList[num].floorBeanList!= undefined ||this.buildList[num].floorBeanList.length>0){
            this.buildList[num].floorBeanList.forEach(i=>{
               i.colisSelect=this.buildList[num].AllisSelect //行选中或取消
               i.unitBeanList.forEach(ii=>{
                  ii.roomBeanList.forEach(iii=>{
                     // if(iii.salesStatus!='OTHER'){
                        iii.isSelect=this.buildList[num].AllisSelect //格子选中或取消
                     // }  
                  })
               })
            })
      }
      if(this.buildList[num].buildHeadBean.unitBeanList!= undefined ||this.buildList[num].buildHeadBean.unitBeanList.length>0){
             this.buildList[num].buildHeadBean.unitBeanList.forEach(i=>{
               i.unitHoldBeanList.forEach(ii=>{
                     ii.rolisSelect=this.buildList[num].AllisSelect//列选中或取消
               })
            })
      }
       console.log('this.buildList',this.buildList[num])
    },
    changefloorSelect(num,n){
      this.buildList[num].floorBeanList[n].colisSelect=!this.buildList[num].floorBeanList[n].colisSelect//行选中或取消
      let flag=this.buildList[num].floorBeanList[n].colisSelect
      this.buildList[num].floorBeanList[n].unitBeanList.forEach(ii=>{
         ii.roomBeanList.forEach(iii=>{
            // if(iii.salesStatus!='OTHER'){
                iii.isSelect=flag//行里格子选中或取消
            //  }  
          })
       })
       //遍历全部判断是否全选中
       let isAll=true
       if(this.buildList[num].floorBeanList!= undefined ||this.buildList[num].floorBeanList.length>0){
            this.buildList[num].floorBeanList.forEach((i,n)=>{
                 if(!i.colisSelect){
                    isAll=false
                 }
            })
      }
      this.buildList[num].AllisSelect=isAll
      //判断列是否选中
        this.buildList[num].buildHeadBean.unitBeanList.forEach((item,nn)=>{
         item.unitHoldBeanList.forEach((item1,nnn)=>{//循环每列判断
            let isRol=true
            this.buildList[num].floorBeanList.forEach((i,n1)=>{
                  i.unitBeanList.forEach((ii,n2)=>{
                     if(n2==nn){//对应单元格
                        ii.roomBeanList.forEach((iii,n3)=>{//对应房间
                           // if(iii.salesStatus!='OTHER'&&!iii.isSelect&&n2==nn&&n3==nnn){

                           if(n3==nnn &&!iii.isSelect){
                              isRol=false
                           }  
                        })
                     }
                   })
               
               }) 
            this.buildList[num].buildHeadBean.unitBeanList[nn].unitHoldBeanList[nnn].rolisSelect=isRol  
          })
       })
      //设置列是否全选

       console.log('this.buildList',this.buildList[num])
    },
    changeunitSelect(num,n,nn){
      this.buildList[num].buildHeadBean.unitBeanList[n].unitHoldBeanList[nn].rolisSelect=!this.buildList[num].buildHeadBean.unitBeanList[n].unitHoldBeanList[nn].rolisSelect//列选中或取消
      let flag= this.buildList[num].buildHeadBean.unitBeanList[n].unitHoldBeanList[nn].rolisSelect
      if(this.buildList[num].floorBeanList!= undefined ||this.buildList[num].floorBeanList.length>0){
            this.buildList[num].floorBeanList.forEach((i,n1)=>{
               i.unitBeanList.forEach((ii,n2)=>{
                  if(n2==n){
                  ii.roomBeanList.forEach((iii,n3)=>{
                     // if(iii.salesStatus!='OTHER'&&n2==n&&n3==nn){
                      if(n3==nn){
                        iii.isSelect=flag //格子选中或取消
                        
                     }  
                  })
                  }
               })

            })
      }

      //遍历全部判断是否全选中
       let isAll=true //全部选中
       
       if(this.buildList[num].floorBeanList!= undefined ||this.buildList[num].floorBeanList.length>0){
            this.buildList[num].floorBeanList.forEach(i=>{
               let isCol=true //行选中
               i.unitBeanList.forEach(ii=>{
                  ii.roomBeanList.forEach(iii=>{
                     // if(iii.salesStatus!='OTHER'&&!iii.isSelect){
                     if(!iii.isSelect){
                        isAll=false
                        isCol=false
                     }  
                  })
               })
               i.colisSelect=isCol
            })
      }
      this.buildList[num].AllisSelect=isAll
    },
    mousemove(e,num,n,nn,nnn){
       this.changeRoomSelect(num,n,nn,nnn)
    },
    changeRoomSelect(num,n,nn,nnn){
       //单元格设置是否选中
        this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn].isSelect=!this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn].isSelect//行选中或取消
        let flag=this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn].isSelect
        //判断行是否选中
       let isCol=true
            this.buildList[num].floorBeanList[n].unitBeanList.forEach(i=>{
               i.roomBeanList.forEach(ii=>{
                     // if(ii.salesStatus!='OTHER'&&!ii.isSelect){
                     if(!ii.isSelect){
                        isCol=false
                     }  
               })
            })
    
      this.buildList[num].floorBeanList[n].colisSelect=isCol
       //判断列是否选中
       let isRol=true
          this.buildList[num].floorBeanList.forEach(i=>{
               i.unitBeanList.forEach((ii,n2)=>{
                  ii.roomBeanList.forEach((iii,n3)=>{
                     // if(iii.salesStatus!='OTHER'&&!iii.isSelect&&n2==nn&&n3==nnn){
                     if(!iii.isSelect&&n2==nn&&n3==nnn){
                        isRol=false
                     }  
                  })
               })
            })     
       this.buildList[num].buildHeadBean.unitBeanList[nn].unitHoldBeanList[nnn].rolisSelect=isRol
        //遍历全部判断是否全选中
       let isAll=true
            this.buildList[num].floorBeanList.forEach(i=>{
               i.unitBeanList.forEach(ii=>{
                  ii.roomBeanList.forEach(iii=>{
                     // if(iii.salesStatus!='OTHER'&&!iii.isSelect){
                     if(!iii.isSelect){
                        isAll=false
                     }  
                  })
               })
            })

      this.buildList[num].AllisSelect=isAll
    },
    cloneDeepJson(obj){
      return JSON.parse(JSON.stringify(obj))
    },
    getBg(color){
       let style=''
       let bg='background-color:'+color+';';
       style=bg;
        if(color=='#fff'||color=='#FFF'||color=='#FFFFFF'||color=='#ffffff'){
            let border='border:1px solid #CECECE;width:8px;height:8px;';
            style=style+border
        }
      // console.log('color',color,'style',style)
      return style
    },
    getItemBg(salesStatus,init){
       let color='#fff';
      //  console.log('this.saleStatusBeanList',this.saleStatusBeanList)
        if( this.saleStatusBeanList != undefined ||  this.saleStatusBeanList > 0){
           this.saleStatusBeanList.forEach(i=>{
               if(i.number==salesStatus){
                  color=i.color
               }
           })
        }
       if(!init){
          color='#fff';
       }
       let style=''
       let bg='background-color:'+color+';';
       style=bg
        if(color=='#fff'||color=='#FFF'||color=='#FFFFFF'||color=='#ffffff'){
            let border='color:#212121;';
           if(init){
               border+='border:1px solid #ccc;box-sizing: border-box;line-height:20px;'
            }
            style=style+border
        }
       return style
    },
     getWidth(n,salesStatus,init,isMore){
         
        if(!n){
           n=1
        }
        let w=60*n+4*(n-1);
      //   let m=2*n;
        let wStyle='width:'+w+'px;';
        if(isMore==1){
           wStyle='width:102px;';
        }
        if(isMore==2){
           wStyle='width:138px;';
        }
        let mStyle='margin:2px 2px;';
        let style=this.getItemBg(salesStatus,init)
      //   console.log('wStyle+mStyle+style',wStyle+mStyle)
        return wStyle+mStyle+style
     },
     mouseClick(e,num,n,nn,nnn,id){
      //   this.buildList[num].floorBeanList[n].unitBeanList[nn].roomBeanList[nnn].isSelect=true;
         // console.log(e.target.value,num,n,nn,'e')
      //  if(e.target.value){
         // let value={
         //    roomId:id
         // }
         // let parm={content:{ type:'click_room', value:value}}
         // console.log('传给后台的参数',parm)
         // this.invoke('invokeCustomEvent',parm) 
     }
  }
};
